import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function listMedia(sectionId) {
  const response = await axiosClient.get(
    `/api/admin/sections/${sectionId}/media`
  );
  return unwrapApiResponse(response);
}

export async function createMedia(sectionId, payload) {
  const response = await axiosClient.post(
    `/api/admin/sections/${sectionId}/media`,
    payload
  );
  return unwrapApiResponse(response);
}

export async function uploadMedia(sectionId, formData) {
  const response = await axiosClient.post(
    `/api/admin/sections/${sectionId}/media/upload`,
    formData
  );
  return unwrapApiResponse(response);
}

export async function updateMedia(mediaId, payload) {
  const response = await axiosClient.put(
    `/api/admin/media/${mediaId}`,
    payload
  );
  return unwrapApiResponse(response);
}

export async function deleteMedia(mediaId) {
  const response = await axiosClient.delete(`/api/admin/media/${mediaId}`);
  return unwrapApiResponse(response);
}
